// extracted by mini-css-extract-plugin
module.exports =  {"root":"XTw9R6YtXrWvcV2cxcur"};